// Sticky behaviour for the country sub-navbar (.destination-navbar).
//
// `_destination_navbar.scss` anchors the sub-navbar below the main navbar
// using two CSS variables that depend on actual rendered heights:
//   --main-navbar-height            height of the main .navbar-wrapper
//   --main-destination-height       height of the main destination row (back
//                                   arrow + country name) inside the sub-navbar
//
// Both values can change with the viewport (responsive layout) and with
// elements appearing/disappearing above the navbar (e.g. promo-banner), so
// they are measured at runtime and refreshed via a ResizeObserver.

export class DestinationNavbarSticky {
  constructor() {
    this.root = document.querySelector(".destination-navbar");
    if (!this.root) return; // No-op on pages without the white sub-navbar.

    this.mainNavbar = document.querySelector(".navbar-wrapper");
    this.tabs = this.root.querySelector(".destination-pages");

    this.update = this.update.bind(this);  // necessary because `update` is called as a callback
    this.update();

    if (typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver(this.update);
      if (this.mainNavbar) observer.observe(this.mainNavbar);
      observer.observe(this.root);
    }

    this._resizeTimer = null;
    window.addEventListener("resize", () => {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(this.update, 250);
    });
  }

  update() {
    if (this.mainNavbar) {
      const h = this.mainNavbar.getBoundingClientRect().height;
      if (h > 0) {
        document.documentElement.style.setProperty("--main-navbar-height", h + "px");
      }
    }
    if (this.tabs && this.root) {
      const navTop = this.root.getBoundingClientRect().top;
      const tabsTop = this.tabs.getBoundingClientRect().top;
      const h = tabsTop - navTop;
      if (h > 0) {
        document.documentElement.style.setProperty("--main-destination-height", h + "px");
      }
    }
  }
}
